import { CardData, MerchantData, PaymentMethod, SwishData } from './generated'

export const isSwishPayment = (
  merchantData?: Partial<MerchantData>
): merchantData is SwishData => merchantData?.type === PaymentMethod.Swish

export const isCardPayment = (
  merchantData?: Partial<MerchantData>
): merchantData is CardData => merchantData?.type === PaymentMethod.Card
